import { z } from 'zod';

export const BetaFlagToggleResponse = z.object({
  message: z.string(),
  flag_key: z.string(),
  enable: z.boolean(),
});

export type BetaFlagToggleResponseType = z.infer<typeof BetaFlagToggleResponse>;
